'use client';

import { atom, useAtom } from 'jotai';

export const iFrameUrlAtom = atom<string | null>(null);

export const mobileAppEmbedUrlAtom = atom<string | null>(null);

/**
 * Sets the iframe URL. Always updates the atom on click.
 * When the user clicks the same URL again (already loaded), re-initiates by
 * clearing the atom then setting the URL again so iframe remounts / Hyperbeam reloads.
 */
export function useSetIframeUrl() {
  const [iframeUrl, setIframeUrl] = useAtom(iFrameUrlAtom);

  return (contentUrl: string) => {
    if (!contentUrl) return;
    if (iframeUrl === contentUrl) {
      setIframeUrl(null);
      setTimeout(() => setIframeUrl(contentUrl), 0);
    } else {
      setIframeUrl(contentUrl);
    }
  };
}
